import { render } from "./ChoiceArgument.vue?vue&type=template&id=554f76d0&scoped=true"
import script from "./ChoiceArgument.vue?vue&type=script&lang=js"
export * from "./ChoiceArgument.vue?vue&type=script&lang=js"

import "./ChoiceArgument.vue?vue&type=style&index=0&id=554f76d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-554f76d0"

export default script